import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeManagerService } from '~/services/theme-manager';

@Component({
    selector: 'asap-donut-chart',
    templateUrl: './donut-chart.html',
    styleUrls: ['./donut-chart.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DonutChartComponent implements OnDestroy {
  public _tooltipVisibility: boolean = true;
  public ChartDataName: any = { data: [] };
  public sum: number = 0;
  public chartAreaBack: string = 'transparent';
  public isDarkTheme: boolean = false;
  private _themeSubscription: Subscription;

  // Enterprise default color palette for pie/donut slices
  private readonly defaultPalette: string[] = [
    '#1E88E5', '#00ACC1', '#8E24AA', '#FFB300',
    '#4CAF50', '#E53935', '#3949AB', '#009688',
    '#FF9800', '#7C4DFF', '#00E676', '#FF5252'
  ];

  constructor(
    private _themeManager: ThemeManagerService,
  ) {
    this.labelContent = this.labelContent.bind(this);
    this.labelColor = this.labelColor.bind(this);
    this.labelFont = this.labelFont.bind(this);

    this._themeSubscription = this._themeManager.themeChange.subscribe(x => {
      this.isDarkTheme = x !== 'enterprise' && x !== 'light';
      this.chartAreaBack = 'transparent';
    });
  }

  public labelContent(e: any): string {
    if (!e || !e.category) return '';
    return `${e.category}\nQty: ${e.value}`;
  }

  public labelColor(e: any): string {
    if (e && e.dataItem && e.dataItem.colorLabel) {
      return e.dataItem.colorLabel;
    }
    return this.isDarkTheme ? '#CBD5E1' : '#334155';
  }

  public labelFont(e: any): string {
    if (e && e.dataItem && e.dataItem.font) {
      return e.dataItem.font;
    }
    return '500 12px Inter, system-ui, -apple-system, sans-serif';
  }

  @Input() public set model(accountData: any) {
    if (!accountData) {
      this.ChartDataName = { data: [] };
      this.sum = 0;
      return;
    }

    let processedData = Array.isArray(accountData.data) ? [...accountData.data] : [];

    // Assign system palette fallback colors if not explicitly defined
    processedData = processedData.map((item: any, index: number) => {
      return {
        ...item,
        color: item.color || this.defaultPalette[index % this.defaultPalette.length]
      };
    });

    this.ChartDataName = {
      ...accountData,
      data: processedData
    };

    if (accountData.sum !== undefined && accountData.sum !== null) {
      this.sum = accountData.sum;
    } else {
      this.sum = processedData.reduce((acc: number, curr: any) => acc + (Number(curr.value) || 0), 0);
    }
  }

  @Input() public set chartTooltip(chartTooltipValue: any) {
    this._tooltipVisibility = chartTooltipValue !== undefined && chartTooltipValue !== null ? chartTooltipValue : true;
  }

  ngOnDestroy(): void {
    if (this._themeSubscription) {
      this._themeSubscription.unsubscribe();
    }
  }
}

